import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, takeEvery, call, put, all, select } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestPleitoPosto({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'pleito/posto', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deletePleitoPosto({ payload }) {
  try {
    const { idpleito, params } = payload;

    yield call(api.delete, `pleito/pleitoposto/${idpleito}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { pleito, params } = payload;

    yield call(api.post, 'pleito/posto', pleito);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/cadacom_pleitoposto');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { idpleito } = payload;

    const { data } = yield call(api.get, `pleito/${idpleito}`);

    // data.param5usuariooperador = JSON.stringify(data.param5usuariooperador);
    // data.param7usuariooperador = JSON.stringify(data.param7usuariooperador);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { pleito, params } = payload;

    yield call(api.put, 'pleito/posto', pleito);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/cadacom_pleitoposto');
  } catch (erros) {
    console.log(erros)
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {

    const { params } = payload

    const response = yield call(api.get, 'pleito/posto', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });


    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    console.log(erros)
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest('@pleitoposto/PLEITOPOSTO_IN_REQUEST', requestPleitoPosto),
  takeLatest('@pleitoposto/DELETE_PLEITOPOSTO', deletePleitoPosto),
  takeLatest('@pleitoposto/SUCCESS_REMOVE', requestPleitoPosto),
  takeLatest('@pleitoposto/STORE_PLEITOPOSTO', store),
  takeLatest('@pleitoposto/FIND_PLEITOPOSTO', find),
  takeLatest('@pleitoposto/UPDATE_PLEITOPOSTO', update),
  takeLatest('@pleitoposto/RECORD_FILTERING', applyedFilters),
]);
